<template>
    <div
        v-if="lvrecList && lvrecList.length >= 3"
        class="contrast-class"
        data-type="anchor"
        data-anchor="contrastclass"
    >
        <h3 class="title">同级对比</h3>
        <div class="class-content">
            <template
                v-for="(item, idx) in lvrecList"
            >
                <router-link
                    class="class-item"
                    :key="item.model_id"
                    :to="{
                        name: 'CONSTRAST',
                        query: {
                            type: 'lvrec',
                            ...mainRec,
                            rec_series_id: item.rec_series_id,
                            rec_model_year: item.rec_model_year
                        }
                    }"
                    target="_blank"
                    @click.native="logContrastClass(item, idx)"
                >
                    <div class="item-info">
                        <img src="@/assets/images/bitmap-small.png" v-real-src="item.white_bg_img">
                        <div>
                            <p class="car-name">{{item.name}}</p>
                            <p class="car-price">{{item.price}}</p>
                        </div>
                    </div>
                    <div class="btn">
                        <p>对</p>
                        <p>比</p>
                    </div>
                </router-link>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * @file 同级对比
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {get} from 'lodash';
import {sendLog} from 'js/log';

export default {
    props: {
        seriesId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            lvrecList: [],
            mainRec: {}
        };
    },
    watch: {
        seriesId(val) {
            this.getSeriesLevelRec(val);
        }
    },
    methods: {
        getSeriesLevelRec(seriesId) {
            /* eslint-disable fecs-camelcase */
            request(URLS.getSeriesLevelRec, {
                series_id: seriesId
            })
                .then(res => {
                    const Result = res.Result;
                    const lvrecList = get(Result, 'lvreclist.result', []).slice(0, 3);
                    const mainRec = {
                        main_model_year: get(Result, 'main_model_year'),
                        main_series_id: get(Result, 'main_series_id')
                    };
                    this.lvrecList = lvrecList;
                    this.mainRec = mainRec;
                    this.$emit('getdatastatus', 'contrastclass', lvrecList.length >= 3);
                }).catch(err => {
                    this.$emit('getdatastatus', 'contrastclass', false);
                });
            /* eslint-enable fecs-camelcase */
        },
        logContrastClass(item, idx) {
            /* eslint-disable fecs-camelcase */
            this.sendLog('same_class', {
                ...this.mainRec,
                rec_series_id: item.rec_series_id,
                rec_model_year: item.rec_model_year,
                pos: idx
            });
            /* eslint-enable fecs-camelcase */
        },
        sendLog(key, params) {
            sendLog(`car_train_${key}`, {
                ...params
            });
        }
    }
};
</script>

<style lang="less" scoped>
.class-content {
    display: flex;
}
.class-item {
    display: flex;
    width: 385px;
    height: 108px;
    border: 1px solid #F1F1F1;
    margin-left: 22.5px;
    &:first-child {
        margin-left: 0;
    }
    .item-info {
        flex: 1;
        display: flex;
        padding-left: 12px;
        align-items: center;
        img {
            display: block;
            width: 126px;
            height: 84px;
            margin-right: 12px;
        }
        .car-name {
            font-size: 18px;
            color: #333333;
        }
        .car-price {
            font-size: 16px;
            color: #FE4455;
        }
    }
    .btn {
        display: flex;
        flex-direction: column;
        width: 50px;
        height: 100%;
        background: #00CECF;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #FFFFFF;
        user-select: none;
        cursor: pointer;
    }
}
</style>
